import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-global-navigation.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const GlobalNavigationSiteFooter = props => {
  const {
    className,
    children
  } = props;
  const baseCssClass = 'global-navigation-footer';
  const wrapperClassNames = getClassNameList(baseCssClass, className);
  const containerClassNames = getClassNameList(`${baseCssClass}-container`);
  return jsx("footer", {
    className: wrapperClassNames,
    children: jsx("div", {
      className: containerClassNames,
      children: children
    })
  });
};
GlobalNavigationSiteFooter.displayName = 'GlobalNavigationSiteFooter';
export { GlobalNavigationSiteFooter };